import React from 'react';
import { Link } from 'react-router-dom';

const Header = props => {
  let { first_name, last_name, photo } = props.trainer;
  let initials =
    first_name && last_name
      ? `${first_name[0].toUpperCase()}${last_name[0].toUpperCase()}`
      : '';
  return (
    <header className="profile-head">
      <div className="profile-avatar">
        <div className="user-avatar">
          {photo ? <img src={photo} /> : <i>{initials}</i>}
        </div>
        <h3>
          {first_name} <br />
          {last_name}
        </h3>
      </div>
      <Link
        to={{
          pathname: '/profile/edit',
          state: {
            trainer: props.trainer
          }
        }}
        className="btn btn-primary"
      >
        Edit Profile
      </Link>
    </header>
  );
};

export default Header;
